import { formatBRL } from "../../../shared/lib/currency";

// Plano Fundador (ADR 0010). O valor real vem de GET /api/v1/billing/status
// (PLAN_PRICE_CENTS no backend); este é só o padrão para quando o status não está
// disponível (ex.: no banner, ou com a assinatura online desligada).
export const DEFAULT_PLAN_PRICE_CENTS = 5900;

// Link alternativo (ex.: WhatsApp) quando a assinatura online está indisponível (503).
// Função (e não constante) para os testes poderem trocar o ambiente.
export function fallbackSubscribeUrl() {
  return process.env.REACT_APP_ASSINATURA_URL;
}

export function formatPlanPrice(priceCents = DEFAULT_PLAN_PRICE_CENTS) {
  return `${formatBRL(priceCents / 100).replace(/,00$/, "")}/mês`;
}

export const PLAN_LABEL = {
  trial: "Teste grátis",
  subscriber: "Assinante",
  free: "Plano grátis (1 vínculo)",
  read_only: "Só leitura",
};

// subscription_ends_at/trial_ends_at são o instante em que o acesso termina (meia-noite
// seguinte ao último dia, no horário de Brasília) — o último dia é o anterior.
export function formatLastAccessDay(endsAt) {
  if (!endsAt) return "";
  const lastInstant = new Date(new Date(endsAt).getTime() - 1);
  return lastInstant.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
}

// "aaaa-mm-dd" → "dd/mm/aaaa" sem passar por Date (não desloca o dia pelo fuso)
export function formatISODate(iso) {
  return iso ? iso.split("-").reverse().join("/") : "";
}
